import React from "react";
import Link from "next/link";
import Image from "next/image";
import { useRouter } from "next/router";
import { observer } from "mobx-react-lite";
import store from "store";
import { Hooks } from "@xt/xtbase";
const {useIntl,FormattedMessage} = Hooks;
import stylesLess from "./index.module.less";
import axios from "utils/axios";
import sessionStorage from "utils/sessionStorage";
import { regexp, doRsaEncrypt } from "utils/method";
import { post_loginByFaBeforeCheck, post_passwdPublicKey } from "api/uaapi/uaa";
import { post_msgDoSendCode } from "api/uaapi/user";

import AntdModalAlert from "components/Antd/Modal/Alert";
import ButtonBig from "components/Antd/Button/big";
import Passcode from "components/App/Passcode";
import FormItem from "components/App/FormItem";
import FormItemInput from "components/App/FormItem/Input";
import FormItemPassword from "components/App/FormItem/Password";
import Geetest from "components/Geetest";
import passcode from "components/App/Passcode";
import { message } from "antd";

export default observer(React.forwardRef(function Mode2(
  { fa, disabled, codeType = "USER_2001", onSubmit, update_email_more, hideVoiceVerification },
  ref
) {
  const intl = useIntl();
  const router = useRouter();
  const {isDark} = store.app;

  const validateItem = ["email", "mobile", "google"];
  const { faItems, email = "", countryCode, faCheckId } = fa;
  const mobile = fa.mobile || "";

  const [state_sendCodeType, setState_sendCodeType] = React.useState("");
  const geetestRef = React.useRef();
  const handleGeetestSuccess = (puzzleValidateString) => {
    if (state_sendCodeType === "email")
      return handleEmailSendCode(puzzleValidateString);
    if (state_sendCodeType === "mobile")
      return handleMobileSendCode(puzzleValidateString);
  };

  const [state_email, setState_email] = React.useState("");
  const [state_email_status, setState_email_status] = React.useState({
    isOK: false,
    errMsg: "",
  });
  const [state_email_hasSend, setState_email_hasSend] = React.useState(false);
  const [state_email_second, setState_email_second] = React.useState(0);
  const [state_email_loading, setState_email_loading] = React.useState(false);
  const verify_email = () => {
    const newVal = state_email;
    const errMsg = intl.formatMessage({ id: "app.plsEnterRightEmailCode" });
    let status = { isOK: true, errMsg: "" };
    if (!newVal || newVal.length < 6) {
      status = { isOK: false, errMsg };
    }

    setState_email_status(status);
    return status;
  };
  React.useEffect(() => {
    setState_email_status({ isOK: false, errMsg: "" });
  }, [state_email]);
  React.useEffect(() => {
    let timeoutFun;
    if (state_email_second) {
      timeoutFun = setTimeout(() => {
        setState_email_second(state_email_second - 1);
      }, 1000);
    }

    return () => clearTimeout(timeoutFun);
  }, [state_email_second]);
  const handleEmailSendCodeClick = () => {
    update_email_more();
    setState_sendCodeType("email");
    try {
      sensors.track("GetCode", {
        service_type: codeType == 102 ? "忘记密码" : "登录",
      });
    } catch (error) {}

    geetestRef.current.verify();
  };
  const handleEmailSendCode = (puzzleValidateString) => {
    setState_email_loading(true);
    const send = {
      codeType,
      faCheckId,
      msgType: 2,
      // receiveAddress: email,
      // puzzleValidateString,
      regChannel: "xt",
    };

    post_msgDoSendCode({
      params: {
        codeType,
      },
      data: send,
      errorPop: true,
      // successPop: true,
    })
      .then(() => {
        setState_email_second(60);
        setState_email_hasSend(true);
        message.success(intl.formatMessage({ id: "login.emailCodeSend" }));
      })
      .finally(() => {
        setState_email_loading(false);
      });
  };

  const [state_mobile, setState_mobile] = React.useState("");
  const [state_mobile_status, setState_mobile_status] = React.useState({
    isOK: false,
    errMsg: "",
  });
  const [state_mobile_hasSend, setState_mobile_hasSend] = React.useState(false);
  const [state_mobile_second, setState_mobile_second] = React.useState(0);
  const [state_mobile_loading, setState_mobile_loading] = React.useState(false);
  const verify_mobile = () => {
    const newVal = state_mobile;
    const errMsg = intl.formatMessage({ id: "app.plsEnterRightMobileCode" });
    let status = { isOK: true, errMsg: "" };
    if (!newVal || newVal.length < 6) {
      status = { isOK: false, errMsg };
    }

    setState_mobile_status(status);
    return status;
  };
  React.useEffect(() => {
    setState_mobile_status({ isOK: false, errMsg: "" });
  }, [state_mobile]);
  React.useEffect(() => {
    let timeoutFun;
    if (state_mobile_second) {
      timeoutFun = setTimeout(() => {
        setState_mobile_second(state_mobile_second - 1);
      }, 1000);
    }

    return () => clearTimeout(timeoutFun);
  }, [state_mobile_second]);
  const handleMobileSendCodeClick = () => {
    setState_sendCodeType("mobile");
    setState_msgType(0);
    try {
      sensors.track("GetCode", {
        service_type: codeType == 102 ? "忘记密码" : "登录",
      });
    } catch (error) {}

    geetestRef.current.verify();
  };
  const handleMobileSendCode = (puzzleValidateString) => {
    setState_mobile_loading(true);
    const send = {
      codeType,
      countryCode,
      msgType: 0, // 语音验证码已注释，固定为短信
      faCheckId,
      // receiveAddress: mobile,
      // puzzleValidateString,
      regChannel: "xt",
    };

    post_msgDoSendCode({
      params: {
        codeType,
      },
      data: send,
      errorPop: true,
      // successPop: true,
    })
      .then(() => {
        setState_mobile_second(60);
        setState_mobile_hasSend(true);
        let id = "login.smsCodeSend";
        // 语音验证码功能已注释 if (state_msgType) { id = "login.voiceCodeSend"; }
        message.success(intl.formatMessage({ id }));
      })
      .finally(() => {
        setState_mobile_loading(false);
      });
  };
  // 语音验证码功能已注释
  const [state_msgType, setState_msgType] = React.useState(0);
  // const handleSendVoiceCode = () => { ... };

  const [state_google, setState_google] = React.useState("");
  const [state_google_status, setState_google_status] = React.useState({
    isOK: false,
    errMsg: "",
  });
  const verify_google = () => {
    const newVal = state_google;
    const errMsg = intl.formatMessage({ id: "app.plsEnterRightGoogleCode" });
    let status = { isOK: true, errMsg: "" };
    if (!newVal || newVal.length < 6) {
      status = { isOK: false, errMsg };
    }

    setState_google_status(status);
    return status;
  };
  React.useEffect(() => {
    setState_google_status({ isOK: false, errMsg: "" });
  }, [state_google]);
  const [state_paste, setState_paste] = React.useState(false);
  React.useEffect(() => {
    if (navigator.clipboard) setState_paste(true);
  }, []);
  const handlePaste = async () => {
    const text = await navigator.clipboard.readText();
    const val = text.slice(0, 6);
    if (/^[0-9]+$/.test(val)) {
      setState_google(val);
    }
  };

  const verify = () => {
    console.log("verify");
    let isOK = true;
    faItems.map((item) => {
      const type = validateItem[item.validateItemType];
      const state = (() => {
        const obj = {
          mobile: {
            verify: verify_mobile,
          },
          email: {
            verify: verify_email,
          },
          google: {
            verify: verify_google,
          },
        };
        return obj[type];
      })();
      if (!state.verify().isOK) isOK = false;
    });

    isOK && handleSubmit();
  };
  const handleSubmit = () => {
    const send = {};
    faItems.map((item) => {
      const type = validateItem[item.validateItemType];
      const state = (() => {
        const obj = {
          mobile: {
            val: state_mobile,
          },
          email: {
            val: state_email,
          },
          google: {
            val: state_google,
          },
        };
        return obj[type];
      })();
      send[type + "Code"] = state.val;
    });
    console.log("send", send);
    onSubmit && onSubmit(send);
  };
  React.useImperativeHandle(ref, () => ({ verify }));
  let nFaItems = [];
  let faMobile = faItems.find((item) => item.validateItemType === 1);
  let faEmail = faItems.find((item) => item.validateItemType === 0);
  let faGa = faItems.find((item) => item.validateItemType === 2);
  if (faMobile) {
    nFaItems.push(faMobile);
  }
  if (faEmail) {
    nFaItems.push(faEmail);
  }
  if (faGa) {
    nFaItems.push(faGa);
  }
  // nFaItems.sort((a, b) => {
  //   return a.validateItemType - b.validateItemType;
  // });
  return (
    <div className={`${stylesLess.main} ${isDark ? "dark" : "light"}`}>
      <Geetest ref={geetestRef} onSuccess={handleGeetestSuccess} />
      {nFaItems.map((item) => {
        const sendCode = intl.formatMessage({ id: `app.sendCode` });
        const resend = intl.formatMessage({ id: `register.resend` });
        const type = validateItem[item.validateItemType];
        const state = (() => {
          const obj = {
            mobile: {
              title: (
                <FormattedMessage
                  id={`login.mobileCodeTip`}
                  values={{
                    0:
                      mobile.length > 7
                        ? mobile.replace(/(\d{3})\d*(\d{4})/, "$1***$2")
                        : mobile.replace(/(\d{2})\d*(\d{2})/, "$1***$2"),
                  }}
                />
              ),
              val: state_mobile,
              set: setState_mobile,
              status: state_mobile_status,
              verify: verify_mobile,
              suffix: (
                <button
                  className={"btntxt"}
                  disabled={!!state_mobile_second || state_mobile_loading}
                  onClick={handleMobileSendCodeClick}
                >
                  {state_mobile_second
                    ? `${state_mobile_second}s`
                    : state_mobile_hasSend
                    ? resend
                    : sendCode}
                </button>
              ),
            },
            email: {
              title: (
                <FormattedMessage
                  id={`login.emailCodeTip`}
                  values={{
                    0: email.replace(/(\w{2}).*(\w{1})@(.*)/, "$1***@$3"),
                  }}
                />
              ),
              val: state_email,
              set: setState_email,
              status: state_email_status,
              verify: verify_email,
              suffix: (
                <button
                  className={"btntxt"}
                  disabled={!!state_email_second || state_email_loading}
                  onClick={handleEmailSendCodeClick}
                >
                  {state_email_second
                    ? `${state_email_second}s`
                    : state_email_hasSend
                    ? resend
                    : sendCode}
                </button>
              ),
            },
            google: {
              title: <FormattedMessage id={`login.googleCodeTip`} />,
              val: state_google,
              set: setState_google,
              status: state_google_status,
              verify: verify_google,
              suffix: state_paste && (
                <button className={"btntxt"} onClick={handlePaste}>
                  <FormattedMessage id={`app.copy`} />
                </button>
              ),
            },
          };
          return obj[type];
        })();
        return (
          <FormItem key={type} title={state.title} errMsg={state.status.errMsg}>
            <FormItemInput
              // placeholder={intl.formatMessage({
              //   id: `login.${type}Code`,
              // })}
              type="tel"
              inputMode="numeric"
              maxLength={6}
              // noCloseBtn={true}
              isErr={!!state.status.errMsg}
              disabled={disabled}
              value={state.val}
              onInput={(val) => /^[0-9]*$/.test(val) && state.set(val)}
              onBlur={() => state.verify(1)}
              suffix={state.suffix}
            />
            {/* 语音验证码功能已注释 */}
            {/* {type === "mobile" && (
              <div data-login-hide-voice style={{...}}>
                <button className={"btntxt atv"} onClick={handleSendVoiceCode}>
                  <FormattedMessage id="login.voiceCode" />
                </button>
              </div>
            )} */}
          </FormItem>
        );
      })}

    </div>
  );
}));
